/**
 * Execution iteration statuses
 */
export enum ExecutionIterationStatusType {
  COMPLETED = 'completed',
  EXECUTION = 'execution',
  DRAWN = 'drawn',
  CREATED = 'created',
  COMPLETED_WITH_ERRORS = 'completed_with_errors',
  NOTHING_SEATED = 'nothing_seated',
  COMPLETELY_SEATED = 'completely_seated',
  PARTIALLY_SEATED = 'partially_seated',
}
